module.exports = __webpack_public_path__ + "img/port-everglades-emergency-power-study-2.9937ea3c.jpg";